import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto, UpdateOneShopImportDto } from "../generated/schema";

type AddImportMethodParams = {
  shopImport: UpdateOneShopImportDto;
  importId: string;
};

export default function useUpdateImportMethod(shop: ShopDto) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();

  const mutation = $api.useMutation("patch", "/shops/{shopId}/imports/{importId}");

  return useMutation({
    onSuccess: () => {
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async ({ shopImport, importId }: AddImportMethodParams) => {
      return mutation.mutateAsync({
        params: { path: { shopId: shop.id, importId } },
        body: shopImport,
      });
    },
  });
}
